import type { BreakfastEventWithAttendees, ReminderOffset } from "../types";

/** Pipe-separated, must match `insert_event_reminder_notification` + unique index. */
export function buildReminderDedupeActionUrl(
  event: BreakfastEventWithAttendees,
  offset: ReminderOffset,
): string {
  const timeAnchor = event.starts_at ?? `${event.event_date}T${event.event_time ?? ""}`;
  const safeAnchor = timeAnchor.replace(/\|/g, " ");
  return `rmd|${event.id}|${safeAnchor}|${offset}`;
}

/**
 * Returns the breakfast event `id` embedded in an EVENT_REMINDER `action_url`, or `null`.
 */
export function parseEventIdFromReminderActionUrl(
  actionUrl: string | null | undefined,
): string | null {
  if (!actionUrl || !actionUrl.startsWith("rmd|")) return null;
  const second = actionUrl.split("|")[1];
  if (!second || !/^[0-9a-f-]{36}$/i.test(second)) return null;
  return second;
}

export function formatOffsetPhraseEs(offset: ReminderOffset): string {
  if (offset === 60) return "en 1 hora";
  return `en ${offset} minutos`;
}
